<template>
  <PlaceCard
    :class="{active: isActive}"
    :key="activity.id"
    :activity="activity"
    :isLoading="isLoading"
    :isRatingShown="!isActive"
    @show-details="onShowDetails"
    @remove="$emit('remove')"
  >
    <template v-slot:image>
      <button class="banner-action" @click.stop="onQuickAddClick" v-if="!activity.isSaved">
        <HeartIcon />
      </button>
      <button class="banner-action" @click.stop="onQuickAddClick" v-if="activity.isSaved">
        <FilledHeartIcon />
      </button>
      <button class="banner-action" @click.stop="$emit('remove')" v-if="activity.isSelected">
        <FilledHeartIcon />
      </button>

      <button
        class="banner-action-schedule"
        :class="{failed: !activity.day}"
        @click.stop="onGetItemTimeOptions"
        v-if="activity.isSelected && !activity.isStay"
      >
        <div class="banner-action-icon">
          <CalendarIcon v-if="activity.day" />
          <NotFitIcon v-else />
        </div>
        <div class="banner-action-details" v-if="activity.day">
          <div class="banner-action-hint">In Itinerary</div>
          <div class="banner-action-description">{{ activity.dayDetails }}</div>
        </div>
        <div class="banner-action-details" v-else>
          <div class="banner-action-description">Did not fit</div>
        </div>
        <div class="banner-action-carret"></div>
      </button>

      <div class="popover-wrapper popover-wrapper--buttons">
        <v-popover
          offset="2"
          trigger="click"
          placement="bottom"
          popoverBaseClass="tooltip popover solution-list-hover-tooltip"
          :open="isActive"
        >
          <template v-slot:popover>
            <div class="popover-content" v-close-popover>
              <div class="shedule-wrapper">
                <SchedulePopover
                  :timeslots="availableTimeSlots"
                  :activity="pendingActivity"
                  :selectedDayLabel="activity.day"
                  :solutionDates="solutionDates"
                  :isLoading="isTimeSlotsPending"
                  @reschedule="onRescheduleClick"
                  @cancel="onCloseScheduler"
                  :recommendedDayLabel="recommendedDayLabel"
                  v-if="isTimeSlotsAvailable"
                >
                  <div class="radio-section" @click.stop="">
                    <RadioInput
                      label="Any"
                      value="Any"
                      :checked="isAnyMealActive"
                      @change="onMealChange('Any')"
                      radio-group-name="meal"
                    />
                        <RadioInput
                          label="Morning"
                          value="Morning"
                          :checked="isMorningActive"
                          @change="onMealChange('Morning')"
                          radio-group-name="meal"
                        />
                        <RadioInput
                          label="Afternoon"
                          value="Afternoon"
                          :checked="isAfternoonActive"
                          @change="onMealChange('Afternoon')"
                          radio-group-name="meal"
                        />
                        <RadioInput
                          label="Evening"
                          value="Evening"
                          :checked="isEveningActive"
                          @change="onMealChange('Evening')"
                          radio-group-name="meal"
                        />
                        <RadioInput
                          label="Night"
                          value="Night"
                          :checked="isNightActive"
                          @change="onMealChange('Night')"
                          radio-group-name="meal"
                        />

                    <!-- <RadioInput
                      label="Lunch"
                      value="Lunch"
                      :checked="isLunchActive"
                      @change="onMealChange('Lunch')"
                      radio-group-name="meal"
                    />
                    <RadioInput
                      label="Dinner"
                      value="Dinner"
                      :checked="isDinnerActive"
                      @change="onMealChange('Dinner')"
                      radio-group-name="meal"
                    /> -->
                  </div>
                </SchedulePopover>
                <div v-else class="not-available">
                  <div class="name">{{ activityName }}</div>
                  <div class="message">
                    <h4>There’s no availability!</h4>
                    <p>
                      This place is either not available for the dates of your trip, or there isn’t a free space in your
                      itinerary.
                    </p>
                  </div>
                  <div class="actions">
                    <button class="core-button" @click.stop="onCloseScheduler">Close</button>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </v-popover>
      </div>
    </template>
    <span v-if="activity && activity.isStay" class="stay-price">Per Night/</span>
    <span v-if="activity && activity.isStay" class="stay-price">room</span>
    <template v-slot:actions>
      <!-- <div v-if="isUnscheduled" class="unscheduled-item">
        <ExclamationIcon class="icon" />
        <div class="details">
          <div class="reason">
            <b>{{ unscheduledReason }}</b>
          </div>
          <div class="hint">Select a new day for this activity</div>
        </div>
        <div class="actions">
          <button
            class="btn amex-primary-btn always-visible"
            @click.stop="onGetItemTimeOptions"
            v-if="!activity.isSelected && (!activity || !activity.isStay) && !isActive"
          >
            Fix
          </button>
        </div>
      </div> -->
      <!-- <transition> -->

      <!-- </transition> -->

      <!-- <button class="btn amex-outlined-btn" v-if="activity.isSelected">Selected!</button> -->
    </template>
  </PlaceCard>
</template>
<script>
import {computed, defineComponent} from '@vue/composition-api';
import PlaceCard from '@common/card/place-card.vue';
// import {RadioInput} from '@mobi-components/amex-poi-details-view';
import '@mobi-components/amex-poi-details-view/dist/amex-poi-details-view.css';
import ExclamationIcon from '@components/svg/exclamation.vue';
import {AmexButton} from '@mobi-components/amex-bluesky-components';
import IconPlus from '@components/svg/plus.vue';
import HeartIcon from '@components/svg/heart.vue';
import FilledHeartIcon from '@components/svg/filled-heart.vue';
import CalendarIcon from '@components/svg/calendar.vue';
import NotFitIcon from '@components/svg/not-fit-icon.vue';
import {SchedulePopover, RadioInput} from '@components/explore-page/details-view/POIDetailsView';
import {VPopover, VClosePopover} from 'v-tooltip';

export default defineComponent({
  components: {
    PlaceCard,
    SchedulePopover,
    RadioInput,
    ExclamationIcon,
    AmexButton,
    IconPlus,
    HeartIcon,
    CalendarIcon,
    NotFitIcon,
    FilledHeartIcon,
    VPopover,
  },
  directives: {
    'close-popover': VClosePopover,
  },
  props: {
    activity: Object,
    pendingActivity: Object,
    isLoading: Boolean,
    isActive: Boolean,
    availableTimeSlots: Array,
    solutionDates: Array,
    isTimeSlotsPending: Boolean,
    recommendedDayLabel: String,
    isMealSelected: Boolean,
    isAnyMealActive: Boolean,
    isMorningActive: Boolean,
    isAfternoonActive: Boolean,
    isEveningActive: Boolean,
    isNightActive: Boolean,
    isUnscheduled: Boolean,
    isAddOnly: Boolean,
  },
  setup(props, {emit}) {
    const onShowDetails = () => {
      emit('show-details');
    };

    const onQuickAddClick = () => {
      emit('quick-add');
    };

    const onCloseScheduler = () => {
      emit('close-schedule');
    };

    const onGetItemTimeOptions = () => {
      emit('get-time-options');
      if (props.isActive) {
        onCloseScheduler();
      }
    };

    const onRescheduleClick = (ev) => {
      emit('reschedule', ev);
    };

    const onMealChange = (v) => {
      emit('meal-changed', v);
    };

    const unscheduledReason = computed(() => {
      return props.activity?.description || '';
    });

    const isTimeSlotsAvailable = computed(() => {
      return props.isTimeSlotsPending || (props.availableTimeSlots && props.availableTimeSlots.length);
    });

    const activityName = computed(() => {
      return props.activity.name;
    });

    return {
      onShowDetails,
      onQuickAddClick,
      onGetItemTimeOptions,
      onCloseScheduler,
      onRescheduleClick,
      onMealChange,
      unscheduledReason,
      isTimeSlotsAvailable,
      activityName,
      // dates,
    };
  },
});
</script>

<style lang="scss" scoped>
@import './common-explore-view.scss';

.always-visible {
  opacity: 1;
}

.unscheduled-item {
  background: #ffffff;
  border: 1px solid #cdcdcd;
  box-sizing: border-box;
  border-radius: 10px;
  padding: 11px;
  display: flex;
}

.details {
  flex: 1;
  padding: 0 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 140%;
  color: #858585;
}

.not-available {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  display: flex;
  flex-direction: column;
}

.name {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 118.14%;
  letter-spacing: -0.005em;
  color: #071d3b;
  padding: 16px;
  border-bottom: 1px solid #f1f1f1;
}

.message {
  padding: 30px;
}

.message h4 {
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 118.14%;
  text-align: center;
  letter-spacing: -0.005em;
  color: #071d3b;
}

.message p {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 118.14%;
  text-align: center;
  letter-spacing: -0.005em;
  color: rgba(7, 29, 59, 0.41);
}

.actions {
  display: flex;
  justify-content: center;
  margin-top: auto;
}

.core-button {
  --core-btn-bg-color: var(--btn-primary-color, hsl(208, 100%, 41%));
  --core-btn-border: var(--btn-primary-color, hsl(208, 100%, 41%));
  --core-btn-color: #fff;
  height: 40px;
  line-height: 41px;
  color: var(--core-btn-color);
  text-decoration: none !important;
  border-radius: 10px;
  padding: 0 60px;
  background-color: var(--core-btn-bg-color);
  border: 1px solid var(--core-btn-border);
  font-size: 16px;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
}

.stay-price {
  display: block;
  line-height: 1;
  margin-top: 5px;
  margin-left: -5px;
}

.stay-price + .stay-price {
  margin-bottom: 5px;
  margin-top: 0;
}
</style>
